export class Category {
    id = 0;
    title = '';
    is_feature = 0;

    childs = new Array<Category>();
}
